// User model
cv.User =  Backbone.RESTModel.extend({
  defaults : {
    'photo_path' : '',
    'first_name' : '',
    'last_name' : ''
  },

  saveMap : {
    'photo_path' : 'photo_path',
    'first_name' : 'first_name',
    'last_name' : 'last_name'
  },

  urlRoot : function(){
    return cv.api_path + '/users';
  },

  initialize: function(){
    console.log('User model loaded.');
  },

  canInOrganization: function(permission){
    if(cv.user.get('permissions').indexOf(permission) != -1){
      return true;
    }
    return false;
  },

  canInCampaign: function(campaign_id, permission){
    // If we are org owner or admin then give all access
    if(cv.user.get('role') == 'super' || cv.user.get('role') == 'organization_owner' || cv.user.get('role') == 'organization_admin'){
      return true;
    }

    // If not, check for certain permissions
    if(_.has(cv.user.get('campaign_permissions'), campaign_id)){
      if(cv.user.get('campaign_permissions')[campaign_id].indexOf(permission) != -1){
        return true;
      }
    }
    return false;
  }
});
Cocktail.mixin(cv.User, cv.mixins.SyncModel);
